import axios from "axios";
import { BASE_URL } from "../../variables";

const fetchMeetingPage = async (url, accumulatedRecords = []) => {
    const response = await axios({
        url,
        method: "get",
    });

    const records = response?.data?.records || [];
    const allRecords = [...accumulatedRecords, ...records];
    const nextRecordsUrl = response?.data?.nextRecordsUrl;

    if (nextRecordsUrl) {
        return fetchMeetingPage(`${BASE_URL}${nextRecordsUrl}`, allRecords);
    }

    return {
        ...response?.data,
        records: allRecords,
    };
};

export const getAllSH3EmailsMeetDetails = async ({ emailList }) => {

    const queryUrl = `${BASE_URL}/services/data/v56.0/query?q=SELECT 
            Id,
            SG__c,
            Zone__c,
            Cluster_Name__c,
            TSI_Territory_Name__c,
            Town_name__c,
            Dealer_City__c,
            Customer_Name__c,
            Population__c,
            Objective_of_meet__c,
            Type_of_DRM__c,
            Town_Selection_criteria__c,
            Dealer_Selection_Criteria__c,
            If_Category_Specific_dealers_then_which__c,
            No_of_PCC_dealers_in_town__c,
            Estimated_no_of_Dealers_to_Participate__c,
            Total_Head_Count_Dealer__c,
            Total_Head_Count_Employee__c,
            Current_monthly_average_sales_of_Town__c,
            Post_DRM_monthly_average_sale_planned__c,
            Total_Cost__c,
            Cost_Per_Head__c,
            Reason_for_Cost__c,
            Tentative_date_of_the_meet__c,
            Actual_Date_of_the_Meet__c,
            Actual_no_of_Dealers_Participated__c,
            BM_remarks__c,
            NSM_Status__c,
            ZSM_Status__c,
            TMM_Status__c,
            NSM_Feedback__c,
            ZSM_Feedback__c,
            TMM_Feedback__c,
            User_Email__c,
            isZSMCreated__c,
            isTMMCreated__c,
            No_of_Dealers_invited__c,
            Reason_for_exceeding_Budget__c,
            Actual_out_of_pocket_expenses__c,
            Budget_out_of_Pocket_expenses__c,
            Primary_Reason_for_DRM__c,
            Updated_Total_Cost__c,
            Updated_Cost_per_Head__c,
            Deviation_Comments__c
         FROM Dealer_Relationship_Meet__c where User_Email__c In (${emailList})`;

    try {
        const data = await fetchMeetingPage(queryUrl);

        if (data) {
            return {
                success: true,
                data,
            };
        } else {
            throw Error("Something Went Wrong..!!");
        }
    } catch (err) {
        return {
            success: false,
            msg: "Somthing Went Wrong..!!",
        };
    }
};
